import { CheckCircleFilled, FolderOutlined } from '@ant-design/icons'
import { Breadcrumb, Button, Empty, Form, message, Modal } from 'antd'
import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import TableComponent from '../../../components/Common/TableComponent'
import moveDocumentStore from './moveDocumentStore'

const UNSELECTED = undefined

const MoveDocumentModal = props => {
  const { visible, onClose, parentFolderId, currentDocument } = props
  const { folders, breadCrumb, isLoading } = moveDocumentStore
  const [selectedDestFolderId, setSelectedDestFolderId] = useState(UNSELECTED)
  const [form] = Form.useForm()
  const typeTab = new URLSearchParams(location.search).get('typeTab') // 👈 lấy từ query string

  useEffect(() => {
    if (visible) {
      changeParentFolderId(parentFolderId)
    }
    return () => {
      moveDocumentStore.clearStore()
    }
  }, [parentFolderId, visible])

  useEffect(() => {
    if (currentDocument) {
      moveDocumentStore.getListFolder(currentDocument.id, typeTab).catch(e => {
        // 👈 Truyền thêm typeTab
        if (e?.errorCode === 'PERMISSION-100') {
          message.error('Không có quyền di chuyển')
        } else {
          message.error('Đã có lỗi xảy ra!')
        }
      })
    }
  }, [moveDocumentStore.parentFolderId])

  const closeAndResetForm = () => {
    setSelectedDestFolderId(UNSELECTED)
    form.resetFields()
    moveDocumentStore.clearStore()
    onClose()
  }

  const columns = [
    {
      align: 'left',
      title: 'Tên',
      key: 'displayName',
      dataIndex: 'displayName',
      render: (text, record) => {
        const isSelected = selectedDestFolderId === record.id
        return (
          <div key={record.id}>
            <span onClick={() => setSelectedDestFolderId(record.id)}>
              {isSelected ? (
                <CheckCircleFilled style={{ color: '#52c41a' }} />
              ) : (
                <FolderOutlined />
              )}
              <span
                style={{
                  fontWeight: isSelected ? 700 : 400,
                  marginLeft: 8,
                }}>
                {record.name}
              </span>
            </span>
          </div>
        )
      },
    },
    {
      align: 'right',
      title: 'Chọn',
      render: record => (
        <Button type="text" onClick={() => changeParentFolderId(record.id)}>
          Mở
        </Button>
      ),
    },
  ]

  const changeParentFolderId = id => {
    moveDocumentStore.parentFolderId = id
  }

  const move = () => {
    try {
      if (currentDocument && selectedDestFolderId !== UNSELECTED) {
        moveDocumentStore.move(currentDocument.id, selectedDestFolderId)
        message.success('Di chuyển tài liệu thành công')
        closeAndResetForm()
      } else {
        message.warn('Vui lòng chọn thư mục cần di chuyển tới')
      }
    } catch (error) {
      moveDocumentStore.isLoading = false
      message.error(error?.vi || 'Đã có lỗi xảy ra!')
    }
  }

  const title = () => {
    if (!currentDocument) return 'Di chuyển'
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <div>Di chuyển {currentDocument?.name}</div>
        <div style={{ display: 'flex', gap: 10 }}>
          <Button onClick={closeAndResetForm} danger>
            Đóng
          </Button>
          <Button onClick={move} type="primary" loading={isLoading}>
            Di chuyển
          </Button>
        </div>
      </div>
    )
  }

  return (
    <Modal
      width={1000}
      footer={null}
      closable={false}
      visible={visible}
      title={title()}>
      <Form form={form} layout="vertical">
        <Breadcrumb style={{ marginBottom: 0 }}>
          {breadCrumb.map(item => (
            <Breadcrumb.Item
              onClick={() => {
                changeParentFolderId(item.id)
                setSelectedDestFolderId(item.id)
              }}
              key={item.id}>
              <a>{item.name}</a>
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>

        <Form.Item>
          <TableComponent
            rowKey="id"
            dataSource={folders}
            columns={columns}
            showHeader={false}
            pagination={false}
            onRow={record => ({
              onClick: () => setSelectedDestFolderId(record.id),
            })}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={'Không có dữ liệu'}
                />
              ),
            }}
            loading={isLoading}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default observer(MoveDocumentModal)
